import Popup from "reactjs-popup";
import '../../../scss/os-global.scss';
import 'reactjs-popup/dist/index.css';
import React, { Component } from "react";
import driversSchoolApi from "../api/driversSchool";
import DriversSchoolCategories from '../api/driversSchoolCategories';
import From from "../../../components/form-component/form";
import { getStaticText } from "../../../lables/lablesService";
import Table from "../../../components/table-data-component/table";
import Spinner from "../../../components/spinner-component/Spinner";

class DriversSchool extends Component {

  constructor(props) {
    super(props);

    this.DataService = driversSchoolApi;
    this.categories = {};
    this.rows = [];
    this.page = 1;
    this.per_page = 10;
    this.all_pages = 0;
    this.order = { 'position': "ASC" };

    this.save_type_process = false;
    this.form_info = {};
    this.empty_form_info = {
      'id': 0,
      'image': '',
      'title': '',
      'content': '',
      'active': 1,
      'position' : 99999,
      'type_id' : 0
    };

    this.state = {
      'has_data': false,
      'show_popup': false
    };
  }

  async getDataList() {
    this.setState({ 'has_data': false });

    let list_response = await this.DataService.getDsList({
      'page': this.page,
      'per_page': this.per_page,
      'order': this.order
    });

    if (typeof (list_response.rows) !== 'undefined') {
      this.rows = list_response.rows;
      this.all_pages = list_response.all_pages;
    }

    this.setState({ 'has_data': true });
  }

  async changePage(page_number = 1) {
    this.page = page_number;
    await this.getDataList();
  }

  async changeOrder(new_order = {}) {
    this.order = new_order;
    await this.getDataList();
  }

  openAddNewForm() {
    this.form_info = {};
    Object.assign(
      this.form_info,
      this.empty_form_info
    );
    this.popupToggle();
  }

  openEditForm(row_for_edit = {}) {
    this.form_info = {};
    Object.assign(
      this.form_info,
      row_for_edit
    );
    this.popupToggle();
  }

  popupToggle() {
    this.setState({ 'show_popup': !this.state.show_popup });
  }

  async saveCallback(info_from_form = {}) {
    let saved = null;

    if (this.form_info.id) {
      saved = await this.DataService.updateDsList(info_from_form);
    } else {
      saved = await this.DataService.addDsList(info_from_form);
    }

    if (!saved) {
      window.alert(getStaticText('save_error'));
    } else {
      window.alert(getStaticText('save_success'));
      this.page = 1;
      this.popupToggle();
      await this.getDataList();
    }
  }

  async deletePost(post_for_delete) {
    if (!window.confirm(getStaticText('remove_confirm_text')))
      return false;

    let result = await this.DataService.deleteDsList(post_for_delete.id);

    if (!result) {
      window.alert(getStaticText('remove_error'));
    } else {
      window.alert(getStaticText('remove_success'));
      this.page = 1;
      this.getDataList();
    }
  }

  async componentDidMount() {
    let categories_response = await DriversSchoolCategories.list({'page' : 1, 'per_page' : 0});
    if ( 
      typeof(categories_response.rows) !== 'undefined' &&
      Object.keys(categories_response.rows).length
    ) {
      for ( let key in categories_response.rows) {
        this.categories[categories_response.rows[key].id] = categories_response.rows[key].name;
      }
    }

    await this.getDataList();
  }

  render() {
    let content = null;

    if (!this.state.has_data) {
      content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
    } else {
      content = (<>
        <div className="col-lg-12 os-text-right">
          <button
            onClick={this.openAddNewForm.bind(this)}
            className="btn btn-success text-white"
          >
            {getStaticText('ds_btn_add_news')}
          </button>
        </div>

        <Popup
          className="os-popup"
          closeOnEscape={false}
          open={this.state.show_popup}
          closeOnDocumentClick={false}
        >
          <>
            <div className="os-popup-header">
              <span className="op-popup-title">
                {this.form_info.id ? getStaticText('ds_edit_popup_title') : getStaticText('ds_add_new_popup_title')}
              </span>
              <button
                onClick={this.popupToggle.bind(this)}
                className="os-popup-close-button"
              >
                <i className="fa fa-times" />
              </button>
            </div>

            <div className="os-popup-body">
              <From
                info={this.form_info}
                sections={{
                  'rtac_form': {
                    'fields': {
                      'image': {
                        'type': 'input_image',
                        'name': 'image',
                        'getDefaultValue': (value) => { return typeof (value) === 'string' ? this.DataService.getImageUrl(value) : value; },
                        'label': getStaticText('ds_img_empty_title')
                      },
                      'title': {
                        'type': 'input_text',
                        'name': 'title',
                        'label': getStaticText('ds_add_form_title')
                      },
                      'type_id' : {
                        'type' : 'input_select',
                        'name' : 'type_id',
                        'label' : getStaticText('ds_add_form_type'),
                        'options' : Object.assign({'0' : getStaticText('ds_add_form_empty_type')}, this.categories)
                      },
                      'content': {
                        'type': 'input_html',
                        'name': 'content',
                        'label': getStaticText('ds_add_form_content')
                      },
                      'position': {
                        'type': 'input_text',
                        'name': 'position',
                        'label': getStaticText('ds_add_form_position')
                      },
                      'active': {
                        'type': 'input_checkbox',
                        'name': 'active',
                        'label': getStaticText('ds_add_active')
                      }
                    }
                  }
                }}
                formDataType="FormData"
                buttonLabel={this.form_info.id ? getStaticText('ds_btn_update_news') : getStaticText('ds_btn_add_news')}
                saveInfoCallback={this.saveCallback.bind(this)}
              />
            </div>
          </>
        </Popup>

        <div className="col-lg-12 pt-3">
          <Table
            currentOrder={this.order}
            changeOrderCallback={this.changeOrder.bind(this)}
            header={{
              'id': {
                'label': getStaticText('ds_id_table'),
                'sortButton': true
              },
              'title': {
                'label': getStaticText('ds_title_table'),
                'sortButton': true
              },
              'type_id': {
                'label': getStaticText('ds_category_table'),
                'sortButton': true
              },
              'active': {
                'label': getStaticText('ds_active_table'),
                'sortButton': true
              },
              'position': {
                'label': getStaticText('ds_position_table'),
                'sortButton': true
              },
              'action': {
                'label': getStaticText('ds_action_table'),
                'sortButton': false
              }
            }}
            body={[
              (row) => { return row.id; },
              (row) => { return row.title; },
              (row) => { return this.categories[row.type_id] || ''; },
              (row) => { return row.active ? getStaticText('ds_active_yes') : getStaticText('ds_active_no'); },
              (row) => { return row.position; },
              (row) => {
                return (
                  <>
                    <button
                      className="btn btn-sm btn-info text-white os-mr-1"
                      title={getStaticText('ds_edit_button_title')}
                      onClick={this.openEditForm.bind(this, row)}
                    >
                      <span className="fa fa-edit"></span>
                    </button>
                    <button
                      className="btn btn-sm btn-danger text-white"
                      title={getStaticText('ds_delete_button_title')}
                      onClick={this.deletePost.bind(this, row)}
                    >
                      <span className="fa fa-trash"></span>
                    </button>
                  </>
                );
              }
            ]}
            rows={this.rows}
            page={this.page}
            allPages={this.all_pages}
            changePageCallback={this.changePage.bind(this)}
            emptyRowsMessage={getStaticText('ds_list_empty')}
          />
        </div>

      </>);
    }

    return (
      <div className="row">
        <div className="col-lg-12">
          <h2>{getStaticText('ds_title')}</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default DriversSchool;